<template>
  <div class="fb-friends">
    <!-- <div class="register-block">
      <div class="fb-user-img">
        <img src="/static/images/Skoraðu-new-4-min.jpg" alt="Facebook user" />
      </div>
      <div class="complaince-block-inner animate-slidein">
        <div class="complaince-text">
          <h4>Skoraðu á vin</h4>
          <p class="sub_text">Átt þú vin sem er golfari eða hefði gaman að spreyta sig á reglunum og mögulega unnið ferðavinning með öllu.</p>
        </div>
        <div class="facebook">
          <button class="button share-btn desktop-view" id="share_btn" @click="sharePage">Skora á vin</button>
          <button class="button share-btn mobile-view" id="share_btn" @click="sharePageMobile">Skora á vini</button>
          <button type="button" class="button nothanx-btn" v-if="this.$data.globalData.user" v-on:click="$emit('proceedToQuiz')">
            Nei takk, halda áfram</button>
        </div>
      </div>
    </div> -->
   </div>
</template>
<script>
/* global FB */
/* eslint no-undef: "error" */
export default {
  name: 'FacebookFriends',
   props: {
    'showFacebook': {
      type: Boolean,
      default: false
    },
    'currentLevel': {
      type: Object,
      default () {
        return {}
      }
    }
   },
  data () {
    return {
      facebookList: null,
      rowCount: 0
    }
  },
  created () {
    this.$emit('proceedToQuiz');
    if (this.$data.globalData.user && this.$data.globalData.user.fb_friends) {
      this.facebookList = this.$data.globalData.user.fb_friends
      this.rowCount = Math.ceil(this.facebookList.length / 2)
    }
  },
  methods: {
    proceed () {
      window.location.href = '/spurningar/'
    },
    sharePage () {
      const currentPage = encodeURI(window.location.href)
      const sharePage = encodeURI(this.$data.globalData.hosted_domain)
      const href = 'http://www.facebook.com/dialog/send?app_id=' + 
      this.globalData.fb_app_id + '&link=' + sharePage + '&redirect_uri=' + this.$data.globalData.hosted_domain + '/spurningar/'
      // FB.ui({
      //   method: 'share',
      //   href: this.$data.globalData.hosted_domain,
      // }, function(response){});
      if (this.currentLevel && this.currentLevel.name) {
        FB.ui({
          method: 'send',
          link: this.$data.globalData.hosted_domain + '/?refer_page= '+  this.currentLevel.name.toLowerCase(),
        });
      } else {
        FB.ui({
          method: 'send',
          link: this.$data.globalData.hosted_domain,
        });
      }
    },
    sharePageMobile () {
      const currentPage = encodeURI(window.location.href)
      const sharePage = encodeURI(this.$data.globalData.hosted_domain)
      const href = 'http://www.facebook.com/dialog/send?app_id=' + 
      this.globalData.fb_app_id + '&link=' + sharePage + '&redirect_uri=' + currentPage
      if (this.currentLevel && this.currentLevel.name) {
        FB.ui({
          method: 'share',
          href: this.$data.globalData.hosted_domain + '/?refer_page='+ this.currentLevel.name.toLowerCase(),
        }, function(response){});
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.fb-friends {
  text-align: center;
  padding: 6rem 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .complaince-block-inner {
    h4 {
      font-weight: 600;
      font-size: 35px;
      line-height: 42px;
    }
    p {
      font-size: 18px;
      line-height: 140%;
      text-align: center;
      color: #011627;
      position: relative;
      max-width: 500px;
      margin: 0 auto;
      padding-bottom: 2rem;
    }
  }
  .register-block {
    padding-top: 8rem;
    padding-bottom: 0;
    .fb-user-img {
      max-width: 600px;
      margin: 0 auto;
      img {
        border-radius: 10pt;
      }
    }
  }
}
.facebook {
  .nothanx-btn {
    padding: 1.3rem 8rem;
  }
}
.button {
  border-radius: 10px
}
@media (max-width: 480px) {
  .facebook  {
    .nothanx-btn {
      padding: 1.3rem 5rem;
    }
    .share-btn {
      padding: 1.3rem 5rem;
    }
  }
   .register-block {
      height: 100%;
   }
  .complaince-block-inner {
    .complaince-text {
      overflow-y: scroll;
      min-height: 164px;
    }
  }
}
</style>
